import * as React from "react"

class CTA extends React.Component {
  showCursor(e) {
    var title = e.currentTarget.getAttribute('data-cursor');
    if(title) {
      document.querySelector('.floating--cursor .caption .inner').innerHTML = title;
    }
    document.querySelector('.floating--cursor').classList.add('active');
  }
  showDragCursor() {
    document.querySelector('.floating--cursor').classList.add('active-drag');
  }
  hideCursor() {
    document.querySelector('.floating--cursor').classList.remove('active');
    document.querySelector('.floating--cursor').classList.remove('active-drag');
  }
  render() {
    return (
    	<>
    		<div className="cta--banner" role="presentation" onMouseEnter={this.showCursor} data-cursor="Enquire" onFocus={this.showCursor} onBlur={this.hideCursor} onMouseLeave={this.hideCursor}>
    			<a className='arrow-expand internal--link' href="/contact"> 
            <div className="m-pr20 m-pl20">
      				<div className="title--animation pos-rel z-2 w-100 h1 normal max-1600 w-100 ma" data-scroll data-scroll-offset="200">
      			 		<span className="text-wrapper first"><span className="word pl10 pr10">Ready to</span></span> 
      			 		<span className="text-wrapper second text-right"><span className="word pl10 pr10">Create Your</span></span> 
      			 		<span className="text-wrapper third text-right"><span className="word pl10 pr10">Mood?</span></span> 
      			 		<span className="text-wrapper fourth"><span className="word pl10 pr10 h1">Let's Chat <div className="arrow-icon" data-scroll data-scroll-offset="300">→</div></span></span> 
      			 	</div>
            </div>
    			</a>
    		</div>
        <div className="spacer m-spacer"></div>
      </>
    )
  } 
}

export default CTA

